export const ZMark = ({ className = "", id = "zg" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <defs>
      <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#2f6bff" />
        <stop offset=".5" stopColor="#22d3ee" />
        <stop offset="1" stopColor="#5cf2a0" />
      </linearGradient>
    </defs>
    <path d="M30 29 H68 L32 71 H70" fill="none" stroke={`url(#${id})`} strokeWidth="14" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
